/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * @author Charles Xie
 */

export const Software = {
  name: <string>'iFlow',
  abbreviation: <string>'IF',
  tagline: <string>'Visualize Computational Thinking',
  url: <string>'https://intofuture.org/iflow',
  authors: <string>'Charles Xie',
  version: <string>'0.0.2'
}

export const Font = {
  label: <string>'9px Arial',
  normal: <string>'10px Arial',
  axisName: <string>'12px Arial',
  highlight: <string>'14px Arial'
}
